const UsersListing = () => import('../../components/User/List')
const UsersManage = () => import('../../components/User/Manage')

export default {
    path: 'users',
    redirect: 'users',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'users',
    meta: {'permissions': 'view-users'},
    children: [
        {
            path: '/',
            component: UsersListing,
        },
        {
            path: 'create',
            name: 'create-user',
            meta: {'permissions': 'create-user'},
            component: UsersManage,
        },
        {
            path: 'update/:id',
            name: 'update-user',
            meta: {'permissions': 'update-user'},
            component: UsersManage,
        },
    ],
};
